<!-- 机票航程  仓位列表 订单填写弹出层  订单详情 改签退票详情 展示  -->
<template>
  <div>
    <van-cell
      v-for="(info,index2) in flight"
      :key="index2"
      class="round-sm"
    >
      <div>
        <van-row
          type="flex"
          align="center"
          class="title"
        >
          <van-col span="20">
            <slot name="tag" />
            <van-tag
              round
              size="medium"
              class="tag-green"
            >
              <!-- <span
                class="font10"
                v-show="index2==0&&flights.length>1||(flights.length==1&&travelType==2&&roundTrip==0)"
              >第1程</span>
              <span
                class="font10"
                v-show="index2==0&&flights.length==1&&travelType!=2"
              >第{{ index + 1 }}程</span>
              <span
                class="font10"
                v-show="index2==1||(flights.length==1&&travelType==2&&roundTrip==1)"
              >第2程</span> -->
              <span class="font10" v-if="info.snStr">{{ info.snStr }}</span>
              <span class="font10" v-else>第{{ index2 + 1 }}程</span>
            </van-tag>&nbsp;
            {{ info.departDate || info.nDepartDate || info.oDepartDate }} {{ info.departDate|week }}
            <span v-show="info.flyTimeStr"><van-icon name="clock-o" />  时长{{ info.flyTimeStr || info.nFlyTime }}</span>
          </van-col>
          <van-col
            span="4"
            class="text-right"
          >
            <van-checkbox
              class="fr"
              v-model="info.checked"
              v-show="info.checkShow"
              @change="$emit('selected',index2,info.checked)"
            />
          </van-col>
        </van-row>
      </div>
      <!--  -->

      <div v-if="info.flyTransfer == true">
        <div>
          <van-row
            type="flex"
            align="center"
            v-if="showCabin&&info.cabin&&info.cabin.cabinName"
            class="row"
          >
            <van-col span="12">
              {{ info.cabin.cabinName }} <span class="red"><span class="font10">&yen;</span> {{
                info.price.salePrice
              }}</span>
            </van-col>
            <van-col
              span="12"
            />
          </van-row>
          <!--          中专的第一个展示-->
          <div class="relative">
            <van-row
              type="flex"
              align="center"
              class="row font16"
            >
              <van-col span="4">
                {{
                  info.transferMap[0].departTime || (info.transferMap[0].nDepartTime | time) || info.transferMap[0].oDepartTime
                }}
              </van-col>
              <van-col span="2">
                <van-icon
                  name="circle"
                  class="line-top"
                />
                <span class="line" />
                <van-icon
                  name="circle"
                  class="line-bottom"
                />
              </van-col>
              <van-col span="16">
                {{ info.transferMap[0].departCityName }}
                {{ info.transferMap[0].departAirportName|airportName }}{{
                  info.transferMap[0].nDepartAirportName|airportName
                }}{{ info.transferMap[0].oDepartCityName|airportName }}
                {{ info.transferMap[0].departTerminal }}
              </van-col>
              <van-col
                span="2"
                v-show="showClear"
                class="text-right"
                @click="$emit('delet',index2)"
              >
                <van-icon
                  class="main-color "
                  name="clear"
                />
              </van-col>
            </van-row>

            <van-row v-if="info.flyTransfer == true">
              <van-col span="5">
                <span class="main-color zzsj">{{ info.transferMap[0].arriveMDDate }}</span>
              </van-col>
              <van-col
                span="19"
              >
                <div>
                  <span v-if="info.flightType == 1">
                    <span v-if="!info.stopOverList.length==0">
                      <span class="stop main-color">停</span>&nbsp;经停：
                    </span>
                  </span>
                  <span v-else-if="info.flightType == 2">
                    <span v-if="!info.stopOverList.length==0">
                      <span
                        class="stop main-color"
                        @click="showPopup"
                      >通</span>&nbsp;通程：
                    </span>
                  </span>
                  <span
                    v-for="(ct, index) in info.stopOverList"
                    :key="index"
                  > {{ ct.cityName }} {{ ct.airportName }} <br>
                    <span v-if="ct.arriveTime == '' ? false : true">{{ $t('ddsj', '到达时间') }}：{{
                      ct.arriveTime
                    }} {{ $t('C124', '起飞时间') }}：{{ ct.departTime }}</span>
                  </span>
                  <span style="background-color: #f6f6f500;">
                    <div class="title gray">
                      <img
                        :src="info.transferMap[0].airlineImg"
                        v-show="info.transferMap[0].airlineImg"
                        class="airIcon"
                      >
                      <span
                        v-show="info.transferMap[0].airlineName"
                      >{{ info.transferMap[0].airlineName }} |</span>
                      {{
                        info.transferMap[0].flightNo || info.transferMap[0].nFlightNo || info.transferMap[0].oFlightNo
                      }}
                      <span
                        v-show="info.transferMap[0].sharFlightNo"
                      >->实际承运
                        <img
                          :src="info.transferMap[0].sharAirlineImg"
                          v-show="info.transferMap[0].sharAirlineImg"
                          class="airIcon"
                        >
                        {{ info.transferMap[0].sharAirlineName }}
                        {{ info.transferMap[0].sharFlightNo }}
                      </span>
                      <span v-if="info.flyTransfer == false">
                        <span v-if="showCabin">{{ info.transferMap[0] | cabinFilter }}</span>
                      </span>
                      <span v-show="info.transferMap[0].saleDiscount">| {{
                        info.transferMap[0].saleDiscount|discount
                      }}</span>
                      <span v-if="info.transferMap[0].planeMap">| {{
                        info.transferMap[0].planeMap[info.plane].planeName
                      }}({{
                        info.planeMap[info.transferMap[0].plane].planeBody
                      }})</span>
                      <span v-else>| {{ info.transferMap[0].planeName }}</span>
                      <span
                        class="food"
                        v-if="info.transferMap[0].hasfood == 1 || info.transferMap[0].hasFood == 1"
                      > | 有餐食</span>
                      <span
                        class="food"
                        v-else
                      > | 无餐食
                      </span>
                      <!--        @click="$dialog.alert({message:'实际乘坐：'+' '+info.sharFlightNo+'</br>请按实际乘坐航班办理值机。'})"-->

                      <!--        @click="$dialog.alert({message:'实际乘坐：'+' '+info.shareFlightNo+'</br>请按实际乘坐航班办理值机。'})"-->
                      <span
                        class="main-color"
                        v-show="info.shareFlightNo"
                        @click="$dialog.alert({message:'实际乘坐：'+' '+info.shareFlightNo+'</br>请按实际乘坐航班办理值机。'})"
                      > {{ $t('C132', '共享') }}</span>
                    </div>
                  </span>
                </div>
                <van-popup
                  v-model="show"
                  position="bottom"
                  round
                  closeable
                  close-icon-position="top-left"
                  :style="{ height: '57%' }"
                >
                  <div class="tc">
                    <p class="nr">
                      通程说明
                    </p>
                    <p class="ts">
                      ·温馨提示
                    </p>
                    <p
                      style="color: #0066ff;font-size: 11.5px;white-space: normal;width: 403px;letter-spacing: 3px;white-space: normal;width: 389px;margin: 10px 0px 0px 12px;"
                    >
                      {{ tc }}
                    </p>
                  </div>
                </van-popup>
              </van-col>
            </van-row>
            <van-row
              type="flex"
              align="center"
              class="row font16"
            >
              <van-col span="4">
                {{
                  info.transferMap[0].arriveTime || (info.transferMap[0].nArriveTime | time) || info.transferMap[0].oArriveTime
                }}
              </van-col>
              <van-col span="2" />
              <van-col span="18">
                {{ info.transferMap[0].arriveCityName }}
                {{ info.transferMap[0].arriveAirportName|airportName }}{{
                  info.transferMap[0].nArriveAirportName|airportName
                }}{{ info.transferMap[0].oArriveCityName|airportName }}
                {{ info.transferMap[0].arriveTerminal }}
              </van-col>
            </van-row>
          </div>
          <!--          中专的第二个展示-->
          <!--显示中转内容-->
          <div
            class="zHz"
            @click="rules(info)"
          >
            <span style="color: #797979;">中转{{ info.flyTransferCityName }}{{ info.flyTransferTimeStr }}</span>
            <van-icon name="arrow" />
          </div>
          <div class="relative">
            <van-row
              type="flex"
              align="center"
              class="row font16"
            >
              <van-col span="4">
                {{
                  info.transferMap[1].departTime || (info.transferMap[1].nDepartTime | time) || info.transferMap[1].oDepartTime
                }}
              </van-col>
              <van-col span="2">
                <van-icon
                  name="circle"
                  class="line-top"
                />
                <span class="line" />
                <van-icon
                  name="circle"
                  class="line-bottom"
                />
              </van-col>
              <van-col span="16">
                {{ info.transferMap[1].departCityName }}
                {{ info.transferMap[1].departAirportName|airportName }}{{
                  info.transferMap[1].nDepartAirportName|airportName
                }}{{ info.transferMap[1].oDepartCityName|airportName }}
                {{ info.transferMap[1].departTerminal }}
              </van-col>
              <van-col
                span="2"
                v-show="showClear"
                class="text-right"
                @click="$emit('delet',index2)"
              >
                <van-icon
                  class="main-color "
                  name="clear"
                />
              </van-col>
            </van-row>

            <van-row
              v-if="info.flyTransfer == true"
              class="dd"
            >
              <van-col span="5">
                <span class="main-color zzsj">{{ info.transferMap[1].arriveMDDate }}</span>
              </van-col>
              <van-col span="19">
                <div>
                  <span v-if="info.flightType == 1">
                    <span class="stop main-color">停</span>&nbsp;经停：
                  </span>
                  <span v-else-if="info.flightType == 2">
                    <span
                      class="stop main-color"
                      @click="showPopup"
                    >通</span>&nbsp;通程：</span>
                  <span
                    v-for="(ct, index) in info.stopOverList"
                    :key="index"
                  > {{ ct.cityName }} {{ ct.airportName }} <br>
                    <span v-if="ct.arriveTime == '' ? false : true">{{ $t('ddsj', '到达时间') }}：{{
                      ct.arriveTime
                    }} {{ $t('C124', '起飞时间') }}：{{ ct.departTime }}</span>
                  </span>
                  <span>
                    <div class="title gray">
                      <img
                        :src="info.transferMap[1].airlineImg"
                        v-show="info.transferMap[1].airlineImg"
                        class="airIcon"
                      >
                      <span
                        v-show="info.transferMap[1].airlineName"
                      >{{ info.transferMap[1].airlineName }} |</span>
                      {{
                        info.transferMap[1].flightNo || info.transferMap[1].nFlightNo || info.transferMap[1].oFlightNo
                      }}
                      <span
                        v-show="info.transferMap[1].sharFlightNo"
                      >->实际承运
                        <img
                          :src="info.transferMap[1].sharAirlineImg"
                          v-show="info.transferMap[1].sharAirlineImg"
                          class="airIcon"
                        >
                        {{ info.transferMap[1].sharAirlineName }}
                        {{ info.transferMap[1].sharFlightNo }}
                      </span>
                      <span v-if="info.flyTransfer == false">
                        <span v-if="showCabin">{{ info.transferMap[1] | cabinFilter }}</span>
                      </span>
                      <span v-show="info.transferMap[1].saleDiscount">| {{
                        info.transferMap[1].saleDiscount|discount
                      }}</span>
                      <span v-if="info.transferMap[1].planeMap">| {{
                        info.transferMap[1].planeMap[info.plane].planeName
                      }}({{
                        info.planeMap[info.transferMap[1].plane].planeBody
                      }})</span>
                      <span v-else>| {{ info.transferMap[1].planeName }}</span>
                      <span
                        class="food"
                        v-if="info.transferMap[1].hasfood == 1 || info.transferMap[1].hasFood == 1"
                      > | 有餐食</span>
                      <span
                        class="food"
                        v-else
                      > | 无餐食
                      </span>
                      <!--        @click="$dialog.alert({message:'实际乘坐：'+' '+info.sharFlightNo+'</br>请按实际乘坐航班办理值机。'})"-->

                      <!--        @click="$dialog.alert({message:'实际乘坐：'+' '+info.shareFlightNo+'</br>请按实际乘坐航班办理值机。'})"-->
                      <span
                        class="main-color"
                        v-show="info.shareFlightNo"
                        @click="$dialog.alert({message:'实际乘坐：'+' '+info.shareFlightNo+'</br>请按实际乘坐航班办理值机。'})"
                      > {{ $t('C132', '共享') }}</span>
                    </div>
                  </span>
                </div>
                <van-popup
                  v-model="show"
                  position="bottom"
                  round
                  closeable
                  close-icon-position="top-left"
                  :style="{ height: '57%' }"
                >
                  <div class="tc">
                    <p class="nr">
                      通程说明
                    </p>
                    <p class="ts">
                      ·温馨提示
                    </p>
                    <p
                      style="color: #0066ff;font-size: 11.5px;white-space: normal;width: 403px;letter-spacing: 3px;white-space: normal;width: 389px;margin: 10px 0px 0px 12px;"
                    >
                      {{ tc }}
                    </p>
                  </div>
                </van-popup>
              </van-col>
            </van-row>
            <van-row
              type="flex"
              align="center"
              class="row font16"
            >
              <van-col span="4">
                {{
                  info.transferMap[1].arriveTime || (info.transferMap[1].nArriveTime | time) || info.transferMap[1].oArriveTime
                }}
              </van-col>
              <van-col span="2" />
              <van-col span="18">
                {{ info.transferMap[1].arriveCityName }}
                {{ info.transferMap[1].arriveAirportName|airportName }}{{
                  info.transferMap[1].nArriveAirportName|airportName
                }}{{ info.transferMap[1].oArriveCityName|airportName }}
                {{ info.transferMap[1].departTerminal }}
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
      <div v-else>
        <div>
          <van-row
            type="flex"
            align="center"
            v-if="showCabin&&info.cabin&&info.cabin.cabinName"
            class="row"
          >
            <van-col span="12">
              {{ info.cabin.cabinName }} <span class="red"><span class="font10">&yen;</span> {{
                info.price.salePrice
              }}</span>
            </van-col>
            <van-col
              span="12"
            />
          </van-row>
          <div class="relative">
            <van-row
              type="flex"
              align="center"
              class="row font16"
            >
              <van-col span="4">
                {{ info.departTime || (info.nDepartTime | time) || info.oDepartTime }}
              </van-col>
              <van-col span="2">
                <van-icon
                  name="circle"
                  class="line-top"
                />
                <span class="line" />
                <van-icon
                  name="circle"
                  class="line-bottom"
                />
              </van-col>
              <van-col span="16">
                {{ info.departCityName }}
                {{ info.departAirportName|airportName }}{{
                  info.nDepartAirportName|airportName
                }}{{ info.oDepartCityName|airportName }} {{ info.departTerminal }}
              </van-col>
              <van-col
                span="2"
                v-show="showClear"
                class="text-right"
                @click="$emit('delet',index2)"
              >
                <van-icon
                  class="main-color "
                  name="clear"
                />
              </van-col>
            </van-row>

            <van-row v-show="info.stopNum>0">
              <van-col span="5" />
              <van-col span="19">
                <div class="stopList font12 gray bg-gray">
                  <span v-if="info.flightType == 1">
                    <span class="stop main-color">停</span>&nbsp;经停：
                  </span>
                  <span v-else-if="info.flightType == 2">
                    <span
                      class="stop main-color"
                      @click="showPopup"
                    >通</span>&nbsp;通程：</span>
                  <span
                    v-for="(ct, index) in info.stopOverList"
                    :key="index"
                  > {{ ct.cityName }} {{ ct.airportName }} <br>
                    <span v-if="ct.arriveTime == '' ? false : true">{{ $t('ddsj', '到达时间') }}：{{
                      ct.arriveTime
                    }} {{ $t('C124', '起飞时间') }}：{{ ct.departTime }}</span>
                  </span>
                </div>
                <van-popup
                  v-model="show"
                  position="bottom"
                  round
                  closeable
                  close-icon-position="top-left"
                  :style="{ height: '57%' }"
                >
                  <div class="tc">
                    <p class="nr">
                      通程说明
                    </p>
                    <p class="ts">
                      ·温馨提示
                    </p>
                    <p
                      style="color: #0066ff;font-size: 11.5px;white-space: normal;width: 403px;letter-spacing: 3px;white-space: normal;width: 389px;margin: 10px 0px 0px 12px;"
                    >
                      {{ tc }}
                    </p>
                  </div>
                </van-popup>
              </van-col>
            </van-row>
            <van-row
              type="flex"
              align="center"
              class="row font16"
            >
              <van-col span="4">
                {{ info.arriveTime || (info.nArriveTime | time) || info.oArriveTime }}
              </van-col>
              <van-col span="2" />
              <van-col span="18">
                {{ info.arriveCityName }}
                {{ info.arriveAirportName|airportName }}{{
                  info.nArriveAirportName|airportName
                }}{{ info.oArriveCityName|airportName }} {{ info.arriveTerminal }}
              </van-col>
            </van-row>
          </div>
        </div>
        <div class="title gray">
          <img
            :src="info.airlineImg"
            v-show="info.airlineImg"
            class="airIcon"
          >
          <span v-show="info.airlineName">{{ info.airlineName }} |</span>
          {{ info.flightNo || info.nFlightNo || info.oFlightNo }}
          <span
            v-show="info.sharFlightNo"
          >->实际承运
            <img
              :src="info.sharAirlineImg"
              v-show="info.sharAirlineImg"
              class="airIcon"
            >
            {{ info.sharAirlineName }}
            {{ info.sharFlightNo }}
          </span>
          <span v-if="info.flyTransfer == false">
            <span v-if="showCabin">{{ info | cabinFilter }}</span>
          </span>
          <span v-show="info.saleDiscount">| {{ info.saleDiscount|discount }}</span>
          <span v-if="info.planeMap">| {{ info.planeMap[info.plane].planeName }}({{
            info.planeMap[info.plane].planeBody
          }})</span>
          <span v-else>| {{ info.planeName }}</span>
          <span
            class="food"
            v-if="info.hasfood == 1 || info.hasFood == 1"
          > | 有餐食</span>
          <span
            class="food"
            v-else
          > | 无餐食
          </span>
          <!--        @click="$dialog.alert({message:'实际乘坐：'+' '+info.sharFlightNo+'</br>请按实际乘坐航班办理值机。'})"-->

          <!--        @click="$dialog.alert({message:'实际乘坐：'+' '+info.shareFlightNo+'</br>请按实际乘坐航班办理值机。'})"-->
          <span
            class="main-color"
            v-show="info.shareFlightNo"
            @click="$dialog.alert({message:'实际乘坐：'+' '+info.shareFlightNo+'</br>请按实际乘坐航班办理值机。'})"
          > {{ $t('C132', '共享') }}</span>
        </div>
      </div>
      <div
        v-show="showRule"
        class="line-height-normal pad-t-5 font12 text-center main-color  van-hairline--top"
        @click="rule(info,index2)"
      >
        {{ $t('F010', '退改签规则') }}
      </div>
      <van-popup
        v-model="showPopup1"
        closeable
        close-icon-position="top-left"
        position="bottom"
        :style="{ height: '73%' }"
        round
        duration="0.5"
      >
        <div>
          <div class="zzs1">
            <p>在{{ info.flyTransferCityName }}中转</p>
            <p style="color: #666">
              <van-icon name="clock-o" />
              时长{{ info.flyTransferTimeStr }}
            </p>
          </div>
          <div>
            <div class="num">
              <ul>
                <li>
                  <span>中转需要我怎么做</span>
                  <p class="num_p">
                    <span>1.第1程到达，需要您重新托运行李 </span>
                    <span>2.需重新值机: 去柜台办理值机</span>
                    <span>3.办理登机</span>
                  </p>
                </li>
                <li>
                  <span>行李提醒</span>
                  <p class="num_p">
                    <span>1.中转{{ info.flyTransferCityName }},行李非直达，旅客需在机场重新办理托运</span>
                  </p>
                </li>
                <li>
                  <span>值机提醒</span>
                  <p class="num_p">
                    <span>1.中转{{ info.flyTransferCityName }}旅客需在机场中转柜台办理下一程的值机手续</span>
                  </p>
                </li>
                <li>
                  <span>预订提示</span>
                  <p class="num_p">
                    <span>1.如遇其中一程航班调整，智通商旅将全力保障您的出行可致电智通商旅或机场柜台自费办理另一程改签或退票。</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </van-popup>
    </van-cell>
    <!--  -->
    <slot name="bottom" />
    <refund-change-rule
      ref="rule"
      :obj="changeRule"
      :cplx="cplx"
    />
  </div>
</template>

<script>
// import refundChangeRule from 'Components/refundChangeRule'
import refundChangeRule from 'Components/refundChangeRule/MultiTripCancellationRules'
import {formatDate} from 'Utils/dateUtil.js'
import {Checkbox, Icon, Tag, Cell, Popup} from 'vant'

export default {
  name: 'Voygae',
  props: {
    flights: {//航班信息
      type: [Array, Object],
      required: true,
      default: function () {
        return []
      }
    },
    index: {
      type: Number,
    },
    showRule: {//是否显示退改规则按钮
      type: Boolean,
      default: false
    },
    showCheck: {//退改签选中按钮
      type: Boolean,
      default: false
    },
    showClear: {//删除行程按钮
      type: Boolean,
      default: false
    },
    showCabin: {//显示舱位
      type: Boolean,
      default: false
    },
    travelType: {
      type: [String, Number],
      default: '0'
    },
    roundTrip: {
      type: [String, Number],
      default: '0'
    }
  },
  components: {
    refundChangeRule,
    [Checkbox.name]: Checkbox,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Cell.name]: Cell,
    [Popup.name]: Popup,
  },
  data() {
    return {
      changeRule: {},
      flight: [],
      cplx: '10901',
      show: false,
      tc: '',
      showPopup1: false,
      TransitTime: '',
    }
  },
  created() {
    this.init()
    this.xc = this.$route.query.second
    console.log(this.$route.query.second)
  },
  methods: {
    rules(info, index) {
      console.log('规则我')
      this.showPopup1 = true
      const duration = info.flyTransferTimeStr
      const hours = parseInt(duration)
      const minutes = parseInt(duration.slice(duration.indexOf('h') + 1, duration.indexOf('m')))
      // 中转时间转化
      this.TransitTime = hours + '小时' + minutes + '分钟'
    },
    showCtr(param) {
      if (param.hasOwnProperty('checkShow')) {
        return this.showCheck && param.checkShow
      } else {
        return this.showCheck
      }
    },
    showPopup() {
      this.show = true
    },
    init() {
      this.flight = []
      let arr = this.flights
      let flight = []
      if (Array.isArray(arr)) {
        if (arr.length > 0) {
          let international = 1
          arr.forEach(item => {
            this.tc = item.flightDes
            if (typeof (item.international) === 'undefined') {
            } else {
              international = item.international
            }
            if (item.stopNum > 0) {
              var flightNo = item.flightNo
              if (null != item.sharFlightNo && '' != item.sharFlightNo) {
                flightNo = item.sharFlightNo
              }
              this.$api['tkQuery/queryFlightStop']({
                'date': item.departDate,
                'flightNo': flightNo,
                'departAirport': item.departAirport,
                'arriveAirport': item.arriveAirport
              }).then(res => {
                let cache = res.data || {}
                item.stopOverList = cache.stopList || []
                flight.push(item)
              }).catch(() => {
                item.stopNum = 0
                flight.push(item)
              })
            } else {
              flight.push(item)
            }
          })
          if (international == 1) {
            this.cplx = '10901'
          } else {
            this.cplx = '10902'
          }
          this.flight = flight
          //    this.$nextTick(function () {
          //     // DOM 现在更新了
          //     // `this` 绑定到当前实例
          //     // this.doSomethingElse()
          //     this.flight=JSON.parse(JSON.stringify(flight))
          // })
          //     this.$forceUpdate()
        }
      }
    },
    rule(info, index) {
      console.log(info, index, '55555')
      this.changeRule = info
      this.$refs.rule.toggle()
    },
  },
  filters: {
    cabinFilter(param) {
      let cabinNameVal = param.cabinName
      let cabinVal = param.cabin
      if (cabinVal.hasOwnProperty('cabinName') || cabinVal.hasOwnProperty('cabin')) {
        let ctrTxt = cabinVal.cabinName || cabinVal.cabin
        return `| ${ctrTxt} `
      } else if (cabinNameVal) {
        return `| ${cabinNameVal} `
      } else {
        return `| ${cabinVal} `
      }
    },
    time(val) {
      if (!val || val.length <= 5) {
        return val
      }
      return formatDate(new Date(val)).hm
    },
    discount(val) {//计算折扣   详情与列表有区别  详情0.  列表1. rubbish
      if (!val) return
      if (val < 1) {
        return (val * 10).toFixed(1) + '折'
      } else if (val == 1) {
        return '全价'
      } else if (val > 1) {
        val = Math.floor(val) / 10
        return val + '倍'
      } else {
        return 0
      }
    }
  },
  watch: {
    'flights.length'() {
      this.init()
    },
  }
}
</script>

<style lang="less" scoped>
@import './business';

.row {
  height: 30px;
}

.title {
  font-size: @font-size-12;
}

.pad-t-5 {
  padding-top: 5px;
}

.stopList {
  display: inline-block;
  padding: 2px 10px 2px 2px;
  border-radius: 10px;
}

.stop {
  display: inline-block;
  padding: 0 4px;
  border-radius: 8px;
  background-color: @color-background-white;
  font-size: @font-size-10;
}

.line {
  display: inline-block;
  position: absolute;
  top: 20px;
  bottom: 20px;
  width: 6px;
  border-right: 1px solid #cccccc;
  height: calc(100% - 40px);
}

.line-bottom, .line-top {
  position: absolute;
  font-size: @font-size-10;
  color: #cccccc;
  background-color: @color-background-white;
}

.line-top {
  top: 10px;
}

.line-bottom {
  bottom: 10px;
}

.tc {
  width: 100%;

  .nr {
    font-size: 15px;
    color: #000;
    font-weight: 600;
    /* margin: 10px; */
    padding: 0.2rem;
    text-align: center;
  }

  .ts {
    display: flex;
    padding: 0.1rem;
    font-size: 14px;
    font-weight: 600;
  }
}

.zHz {
  width: 210px;
  height: 29px;
  line-height: 29px;
  background: inherit;
  background-color: #f2f2f2;
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly;
  margin-left: 64px;
  border-radius: 5px;
}


.dd {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
}

.zzsj {
  position: relative;
  top: 10px;
}

.zzs1 {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: 0.792rem;
  margin: 0 1.792rem;
  text-align: center;
  color: #333;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  flex-direction: column;
  margin: 9px 0px -5px 0px
}

.num {
  ul {
    padding: 20px 20px 20px 20px;

    li:before {
      content: "";
      width: 6px;
      height: 6px;
      display: inline-block;
      border-radius: 50%;
      background: #da924e;
      vertical-align: middle;
      margin-right: 8px;
      margin-top: -4px;
    }
  }
}

.num {
  ul {
    padding: 20px 20px 20px 20px;

    li:before {
      content: "";
      width: 6px;
      height: 6px;
      display: inline-block;
      border-radius: 50%;
      background: #da924e;
      vertical-align: middle;
      margin-right: 8px;
      margin-top: -4px;
    }

    li {
      margin: 10px 0 10px 0px;
    }
  }
}

.num_p {
  padding: 5px 0 0 35px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: stretch;
  color: #666;
}
</style>
